import PropTypes from 'prop-types';

export default function OutlineArrowLeft(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m9 15-5-5 5-5"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path d="M16.5 9.25a.75.75 0 0 1 0 1.5v-1.5Zm-12 0h12v1.5h-12v-1.5Z" fill={color} />
        </svg>
    );
}

OutlineArrowLeft.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
